import React from 'react'

function NotFound() {
  return (
    <h1 style={{ textAlign:'center' }}> Page Not Found </h1>
  )
}

export default NotFound